import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { catchError, EMPTY, finalize, Observable } from 'rxjs';
import { SharedService } from '../shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class PrintDocumentService {
  private readonly BASE_URL: string = '/api/v1/doc';

  constructor(private httpClient: HttpClient, private sharedService:SharedService) { }

  getPolicyDocument(policyId): Observable<any> {
    return this.httpClient.get<any>(`${this.BASE_URL}/${policyId}/1`, { params: { dateTo: moment().format('DD.MM.yyyy') } });
  }

  downloadDetails() {
    this.sharedService.loadingSpinner=true;
    const headers = new HttpHeaders({
      'X-Language': 'en'
    });
    return this.httpClient
      .get(`/api/v1/pdf?documentType=BENEFIT_QUIDE`, { responseType: 'text', observe: 'response', headers:headers })
      .pipe(finalize(()=>{
        this.sharedService.loadingSpinner=false;
      }), catchError((err)=>{
        this.sharedService.loadingSpinner=false;
        throw EMPTY;
      }))
      .subscribe((res) => {
        const response = JSON.parse(res.body);
        const baseArray=atob(response.blobPDF);
        const binary = atob(baseArray.replace(/\s/g, ''));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        let view = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
        }
        let theBlob = new Blob([view], { type: "application/pdf" });
        let URLObject = URL.createObjectURL(new Blob([view], { type: "application/pdf" }));
        window.open((URLObject), '_blank');
        let a = document.createElement("a");
        a.href = URLObject;
        a.download = "MyCar_Packages_" + "Details" + ".pdf";
      });
  }
}
